'use client';

import { SmartProvider } from '@mfrm/design-library';
export default SmartProvider;
